import { Button, Stack } from "@mui/material";
import SectionHeading from "../MostPopularJob/SectionHeading";
import SectionsSecondaryHeading from "../MostPopularJob/SectionsSecondaryHeading";

function JoinPitchersTodaySection() {
  return (
    <Stack
      direction="column"
      sx={{
        bgcolor: "#F8F8F8",
        borderRadius: "50px",
        my: "80px",
        mx: "60px",
        justifyContent: "center",
        alignItems: "center",
        py: "60px",
      }}
    >
      <SectionHeading>
        Join Pitchers today and take the first step towards finding your dream
        job!
      </SectionHeading>
      <SectionsSecondaryHeading py="30px">
        With our user-friendly platform and up-to-date job listings, you'll be
        on your way to a fulfilling career in no time. Sign up now and see what
        opportunities await!
      </SectionsSecondaryHeading>
      <Button
        variant="contained"
        sx={{
          borderRadius: "30px",
          px: "24px",
          minWidth: "auto",
          width: "auto",
          textTransform: "none",
          bgcolor: "#1E1E1E",
          color: "#ffffff",
          boxShadow: "none",
          py: "12px",
          fontSize: "16px",
          lineHeight: "26px",
          fontFamily: "Inter",
          fontWeight: "600",
        }}
      >
        Join Now
      </Button>
    </Stack>
  );
}

export default JoinPitchersTodaySection;
